import "./index.scss";
import "../index.scss";
import React from "react";
import PropTypes from "prop-types";
import { fetchImage } from "../../nonUIFuncs";

const GameSelect = (props) => {
  return (
    <div className="EM-GS-container">
      <div className="EM-topBanner">
        <div className="EM-topBanner-inner">Choose A Game</div>
      </div>

      <div className="EM-container">
        {props.games.map((datum) => {
          let gameSpecLvlData = props.levelData.filter(
            (game) => game.spreadGameType === datum
          );
          let bestEasy = gameSpecLvlData[0];
          let bestMedium = gameSpecLvlData[0];
          let bestHard = gameSpecLvlData[0];
          if (gameSpecLvlData.length === 0) {
            return null;
          }
          gameSpecLvlData.map((game) => {
            if (game.levelEasy > bestEasy.levelEasy) {
              bestEasy = game;
            }
            if (game.levelMedium > bestMedium.levelMedium) {
              bestMedium = game;
            }
            if (game.levelHard > bestHard.levelHard) {
              bestHard = game;
            }
          });
          let gameImg = datum.replaceAll("-", "_").replaceAll(" ", "_");
          let image = `Game_Type_${gameImg}2x.png`;
          return (
            <div
              id={datum}
              className="EM-GS-buttonContainer"
              onClick={() => props.findCategories(datum)}
              key={datum}
            >
              <div className="EM-GS-buttonTitleContainer">
                <div className="EM-GS-buttonTitle">{datum}</div>
              </div>
              <div className="EM-GS-buttonContent">
                <div className="EM-GS-difficultyDisplay">
                  {bestEasy.levelEasy > 0 ? (
                    <div className="EM-GS-difficultyDisplayInner-easy">
                      {typeof bestEasy.category === "string"
                        ? bestEasy.category
                        : bestEasy.category.map((str) => {
                            return <div key={str}> {str}</div>;
                          })}
                      : Lvl {bestEasy.levelEasy}
                    </div>
                  ) : (
                    <div>No score for Easy</div>
                  )}
                </div>

                <div
                  style={{
                    border: "rgba(255,255,255,0.6) 3px outset",
                    width: "90%",
                  }}
                />

                <div className="EM-GS-difficultyDisplay">
                  {bestMedium.levelMedium > 0 ? (
                    <div className="EM-GS-difficultyDisplayInner-medium">
                      {typeof bestMedium.category === "string"
                        ? bestMedium.category
                        : bestMedium.category.map((str) => {
                            return <div key={str}> {str}</div>;
                          })}
                      : Lvl {bestMedium.levelMedium}
                    </div>
                  ) : (
                    <div>No score for Medium</div>
                  )}
                </div>

                <div
                  style={{
                    border: "rgba(255,255,255,0.6) 3px outset",
                    width: "90%",
                  }}
                />

                <div className="EM-GS-difficultyDisplay">
                  {bestHard.levelHard > 0 ? (
                    <div className="EM-GS-difficultyDisplayInner-hard">
                      {typeof bestHard.category === "string"
                        ? bestHard.category
                        : bestHard.category.map((str) => {
                            return <div key={str}> {str}</div>;
                          })}
                      : Lvl {bestHard.levelHard}
                    </div>
                  ) : (
                    <div>No score for Hard</div>
                  )}
                </div>
              </div>
              <div className="EM-GS-Go-Button">
                <div className="EM-GS-buttonTitle">Go!</div>
              </div>
              <div
                className="EM-GS-badge"
                style={{ backgroundImage: `url(${fetchImage(image)})` }}
              />
            </div>
          );
        })}
      </div>
      <div style={{height: 100}} />
    </div>
  );
};

export default GameSelect;

GameSelect.propTypes = {
  findCategories: PropTypes.func,
  games: PropTypes.array,
  levelData: PropTypes.array,
};
